import styled from 'styled-components';
import { mx } from '@lendi-ui/spacing';
import { Body } from '@lendi-ui/typography';
import { deriveSize } from '@lendi-ui/utils';

export const TextFieldJoiner = styled(Body)`
  display: flex;
  align-items: center;
  height: ${deriveSize(3)};
  ${mx('xxs')}
`;
